export default (responsibilities, email) => {
  if (!responsibilities.length)
    return `Finish setting up your account for ${email}.`;
  if (responsibilities.length > 1)
    return `Finish setting up your account for ${email} to access your hiring pipeline and manage your team.`;

  switch (responsibilities[0]) {
    case "hiring":
      return `Finish setting up your account for ${email} to access your hiring pipeline, interviews, and candidate feedback.`;
    case "people_management":
      return `Finish setting up your account for ${email} to access time & attendance, personnel, expenses, and reports.`;
    default:
      return null;
  }
};
